<template>
  <div
    class="c-app flex-row align-items-center"
    style="
         height: 100%;
        background-position: center;
        width: 100%;"
  >
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b> <font color="Green">SMM</font></b>
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b> <font color="Green">SMM</font></b>
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">List Equipment Breakdown</font></b>
                  </h5>
                </div>
                <div class="card-body" style="padding:0rem;">
                  <CCol style="width: 100%;padding: 0px;">
                    <table>
                      <tr>
                        <td style="font-weight: bold;">No</td>
                        <td style="font-weight: bold;">Code</td>
                        <td style="font-weight: bold;">Type</td>
                        <td style="font-weight: bold;">Status</td>
                      </tr>
                      <tr v-for="(item, index, i) in this.data" :key="item.Oid">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.EquipmentCode }}</td>
                        <td>{{ item.EquipmentType }}</td>
                        <td>{{ item.Status }}</td>
                      </tr>
                    </table>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
        </main>
      </div>
    </CWrapper>
  </div>
</template>
<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { DxPieChart, DxConnector } from "devextreme-vue/pie-chart";
import {
  DxSeries,
  DxLegend,
  DxLabel,
  DxFont,
  DxExport,
  DxTooltip,
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxGrid,
  DxCrosshair,
  DxPoint,
  DxTitle,
  DxSubtitle,
  DxValueAxis,
} from "devextreme-vue/chart";
import TheSidebar from "../../containers/TheSidebar";
import TheHeader from "../../containers/TheHeader";
import nav from "../../containers/_nav";
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import CryptoJS from "crypto-js";
Vue.use(VueCordova);

export default {
  components: {
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxGrid,
    DxCrosshair,
    DxExport,
    DxLegend,
    DxPoint,
    DxLabel,
    DxFont,
    DxTitle,
    DxSubtitle,
    DxTooltip,
    TheSidebar,
    TheHeader,
    DxValueAxis,
    DxPieChart,
    DxConnector,
  },
  nav,
  computed: {},
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      month: "",
      year: "",
      data: [],
    };
  },
  methods: {
    formatLabel(pointInfo) {
      return `${pointInfo.percentText}`;
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    Minimize() {
      return this.$store.state.sidebarMinimize;
    },
    reloadData(url) {
      let data = localStorage.token;
      console.log(data);
      this.loading = true;
      axios
        .get(`${url}/Api/Dashboard/SmmBreakdown/`, {
          headers: {
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
          this.data = res.data;
        })
        .catch((error) => {
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
      this.loading = false;
    },
  },
  beforeMount() {
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    this.loading = true;
    this.reloadData(urlS);
    this.loading = false;
  },
};
</script>
<style>
#chart {
  height: 440px;
}

.tooltip-header {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  border-bottom: 1px solid #c5c5c5;
}

.tooltip-body {
  width: 170px;
}

.tooltip-body .series-name {
  font-weight: normal;
  opacity: 0.6;
  display: inline-block;
  line-height: 1.5;
  padding-right: 10px;
  width: 126px;
}

.tooltip-body .value-text {
  display: inline-block;
  line-height: 1.5;
  width: 30px;
}
</style>
